export default {
	lang: 'it',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"VORMOR AI",
		"nav2":"Sicurezza dell'account",
		"nav3":"Il mio disco cloud",
		"nav4":"Disconnettersi",
		"nav5":"Login",
		"nav6":"Spazio nuvola",
		"nav7":"ChatGPT modello grande",
		"nav8":"Sistema di registrazione vocale intelligente Cloud Space",
		"nav_phone_number_code":'Numero di telefono',
		"nav_update":'Sostituire',
		"nav_bind":'bind',
		"nav_phone_code_tips":`Per confermare che è tu a operare, completa la verifica dell'identità tramite il codice di verifica sul telefono`,
		"nav_phone_number":'Numero di telefono',
		"nav_phone_number_verify":'Passa alla verifica del numero di telefono',
		"nav_phone_email_verify":'Passa alla verifica email',
		"nav_set_phone_number":'Imposta un nuovo numero di telefono',
		"nav_verify_login":'Verifica accesso',
		"nav_phone_email":'Email/Numero di telefono',
		"nav_phone_login":'Login con verifica del telefono',
		"nav_email_login":'Accesso con verifica email',
		"nav_email_fail":'Formato email errato, per favore inseriscilo nuovamente',
		"nav_pw_fail":'Formato password errato, si prega di reinserire',
		"nav_code_fail":'Codice di verifica errato',
		"nav_phone_fail":'Formato numero di telefono non valido, si prega di inserirlo nuovamente',
		"nav_input_fail":'Inserisci un indirizzo email',
		"nav_input_phone":'Inserisci il numero di telefono',
		"nav_phone_verify_back":'Recupero con verifica del telefono',
		"nav_email_verify_back":'Recupero verifica email'
	},
	login: {
		"login1":"Accesso con password",
		"login2":"Accesso tramite SMS",
		"loginTab3":"Accesso e-mail",
		"login3":"Posta",
		"login4":"Password di accesso",
		"login5":"Numero di telefono",
		"login6":"Si prega di selezionare",
		"login7":"Codice di verifica mobile",
		"login8":"Login",
		"login9":"dimenticare la password",
		"login10":"registro",
		"login11":"Accedendo accetti",
		"login12":"Contratto di servizio",
		"login13":"politica sulla riservatezza",
		"login14":"Ottenere",
		"login15":"Cina",
		"login16":"Inserisci il tuo numero di conto",
		"login17":"Inserisci la tua password",
		"login18":"Accesso effettuato con successo!",
		"login19":"Inserisci il codice di verifica!",
		"login20":"Inviato con successo!",
		"login21":"E",
		"login22":"Disco cloud con registratore vocale",
		"login23":"La mia scrittura",
		"login24":"La mia conversazione",
		"login25":"Sicurezza dell'account",
		"login26":"Disconnettersi",
		"login27":"Recupera la password via email",
		"login28":"Posta",
		"login29":"Codice di verifica e-mail",
		"login30":"Imposta una password di accesso (6-16 caratteri)",
		"login31":"Reinserisci la tua password di accesso",
		"login32":"invia",
		"login33":"Torna al login",
		"login34":"Modifica riuscita!",
	},
	register: {
		"register1":"Numero di telefono",
		"register2":"Inserisci il tuo numero di telefono",
		"register3":"Si prega di selezionare",
		"register4":"Codice di verifica mobile",
		"register5":"Imposta password",
		"register6":"Inserisci il codice di verifica",
		"register7":"6-16 caratteri",
		"register8":"Conferma della password",
		"register9":"Posta",
		"register10":"Inserisci il tuo indirizzo email",
		"register11":"Codice di verifica e-mail",
		"register12":"Inserisci il codice di verifica",
		"register13":"Ho letto e accetto",
		"register14":"Si prega di leggere e spuntare la casella che accetta l'accordo",
		"register15":"Il formato del numero di telefono non è corretto/il numero di telefono è stato registrato",
		"register16":"Errore del codice di verifica mobile",
		"register17":"Inserisci il tuo indirizzo email / Il formato dell'indirizzo email non è corretto",
		"register18":"Errore nel formato dell'email",
		"register19":"Errore nel codice di verifica dell'email",
		"register20":"Si prega di impostare la password su 6-16 caratteri",
		"register21":"Errore nel formato della password",
		"register22":"Le password inserite due volte non corrispondono. Inseriscile di nuovo.",
		"register23":"Inserisci la tua password",
		"register24":"Registrazione avvenuta con successo!",
		"register25":"Errore nel codice di verifica",
	},
	recorder:{
		"recorder1":"Disco cloud con registratore vocale",
		"recorder2":"Capacità dello spazio cloud",
		"recorder3":"documento",
		"recorder331":"Cestino",
		"recorder332":"Cancella tutto",
		"recorder4":"nome",
		"recorder5":"Durata audio",
		"recorder6":"Dimensione del file",
		"recorder7":"Tempo di creazione",
		"recorder8":"operare",
		"recorder9":"Descrizione dello spazio cloud",
		"recorder10":"documento",
		 "recorder12":'1. Utilizzo dello spazio cloud',
		 "recorder13": 'Dopo aver salvato le registrazioni e le note scritte a mano su un libretto di ufficio intelligente, una penna di registrazione, puoi caricare il cloud drive e accedere allo spazio cloud per visualizzare i file delle note anche se il dispositivo intelligente non è presente. ',
		 "recorder14":'2. Come caricare lo spazio cloud? ',
		 "recorder15":'Recorder Pen: Vai al dispositivo I miei file → Fai clic su Batch → Fai clic su "Carica" per aggiungere i file alla coda di caricamento nel cloud e caricare nel cloud. ',
		 "recorder16":'Libro di ufficio intelligente:',
		 "recorder17":'Modo 1: premere lungo sulla lista delle note, selezionare in lotto le note da caricare → fare clic su "Sincronizza" per completare il caricamento; ',
		 "recorder171":'Modo 2: Apri la pagina dei dettagli di una singola nota → Fai clic su Altro - Sincronizza per caricare la nota nel cloud. ',
		"recorder18":"Non trascritto",
		"recorder19":"Visualizza il riepilogo",
		"recorder20":"Oratore",
		"recorder21":"Modifica il nome dell'oratore",
		"recorder22":"Sicuro",
		"recorder23":"scaricamento",
		"recorder24":"Scarica il contenuto:",
		"recorder25":"Impostazioni di download:",
		"recorder26":"Mostra relatore",
		"recorder27":"Cancellare",
		"recorder28":"Condivisione dei link",
		"recorder29":"Chiunque riceva il link può accedervi. È solo per la lettura e il link è valido per 7 giorni.",
		"recorder30":"Copia il collegamento",
		"recorder31":"Scansiona e visualizza rapidamente",
		"recorder32":"Organizzazione intelligente",
		"recorder33":"Distinguere tra i parlanti",
		"recorder34":"Distinguere in modo intelligente il testo trascritto in base al ruolo del parlante",
		"recorder35":"Regolarizzazione intelligente del linguaggio parlato",
		"recorder36":"Filtra automaticamente le particelle modali, le parole ripetute e le parole in pausa",
		"recorder37":"Filtraggio non vocale",
		"recorder38":"Salta automaticamente l'audio senza voce o rumore durante la riproduzione",
		"recorder39":"Si prega di selezionare",
		"recorder40":"documento",
		"recorder41":"Audio",
		"recorder42":"Documenti + Audio",
		"recorder43":"suggerimento",
		"recorder44":"Questa operazione eliminerà dei file. Vuoi continuare?",
		"recorder441":"Questa operazione eliminerà tutti i file. Vuoi continuare?",
		"recorder45":"Sicuro",
		"recorder46":"Cancellare",
		"recorder47":"Eliminato con successo!",
		"recorder48":"Non cancellato",
		"recorder49":"Nessun tag ancora",
		"recorder50":"Risparmio...",
		"recorder51":"Cestino",
	},
	personal: {
		"personal1":"Impostazioni dell'account",
		"personal2":"informazioni personali",
		"personal3":"avatar",
		"personal4":"Carica file",
		"personal5":"Supporta gli stili JPG, JPEG, GIF, PNG, supporta immagini entro 2M",
		"personal6":"soprannome",
		"personal7":"Inserisci il tuo nickname",
		"personal8":"genere",
		"personal9":"signori",
		"personal10":"Mancare",
		"personal11":"Riservatezza",
		"personal12":"Compleanno",
		"personal13":"Seleziona la tua data di nascita",
		"personal14":"Professione",
		"personal15":"Seleziona la tua professione",
		"personal16":"Inserisci la tua professione (facoltativo)",
		"personal17":"nazione",
		"personal18":"Seleziona il tuo paese",
		"personal19":"Mantenere",
		"personal20":"informazioni personali",
		"personal21":"Sicurezza dell'account",
		"personal22":"Supporta solo immagini entro 2M",
		"personal23":"Caricamento effettuato con successo!",
		"personal24":"Modifica riuscita!",
		"personal25":"Sicurezza dell'account",
		"personal26":"Password di accesso",
		"personal27":"Rivedere",
		"personal28":"E-mail",
		"personal29":"sostituire",
		"personal30":"Cancellazione dell'account",
		"personal32":"Sei sicuro di voler cancellare il tuo account?",
		"personal33":"Dopo aver effettuato il logout, tutti i contenuti del tuo account verranno cancellati, quindi procedi con cautela.",
		"personal34":"Cancellare",
		"personal35":"Sicuro",
		"personal36":"Autenticazione",
		"personal37":"Per confermare che sei tu a farlo, completa la verifica dell'identità tramite il codice di verifica e-mail",
		"personal38":"Posta",
		"personal39":"Codice di verifica",
		"personal40":"Inserisci il codice di verifica",
		"personal41":"Passo successivo",
		"personal42":"Imposta una nuova casella di posta",
		"personal43":"Posta",
		"personal44":"Inserisci un nuovo indirizzo email",
		"personal45":"Codice di verifica",
		"personal46":"Inserisci il codice di verifica",
		"personal47":"Sicuro",
		"personal48":"Imposta una nuova password di accesso",
		"personal49":"Nuova password di accesso",
		"personal50":"Inserisci la nuova password",
		"personal51":"Conferma nuova password",
		"personal52":"Inserisci nuovamente la tua nuova password",
		"personal53":"Sicuro",
		"personal54":"Ottenere",
		"personal55":"Errore nel formato dell'email",
		"personal56":"Sostituzione riuscita!",
		"personal57":"Si prega di impostare la password su 6-16 caratteri",
		"personal58":"Le password inserite due volte non corrispondono",
		"personal59":"Modifica riuscita!",
		"personal60":"Disconnessione avvenuta con successo!",
		
		"share_url": "Condivisione link",
		"share_url_7_day": "Il link di condivisione è valido per 7 giorni. Prima della scadenza, chiunque riceva il link può accedervi.",
		"share_audio": "Registrazione audio",
		"share_trans_text": "Trascrizione",
		"share_summny_text": "Riepilogo",
		"share_map": "Mappa mentale",
		"share_url_pw": "Crittografia di accesso",
		"share_random_pw": "Password generata casualmente",
		"share_url_copy": "Copia link",
		"share_url_copy_success": "Copia collegamento con successo",
		"share_link_pw": "Password di accesso",
		"share_copy_success": "La trascrizione è stata copiata negli appunti!",
		"share_copy_success2": "Il riassunto è stato copiato negli appunti!",
		"share_speaker": "Altoparlante",
		"share_no_update_speaker": "Impossibile modificare. L'altoparlante è vuoto",
		"share_no_trans":"No trascrizione",
		"share_no_summny":"Nessun riepilogo",
		"share_no_map":"Nessun contenuto sulla mappa",
		"share_trans_text_1": "Trascrizione",
		"share_summny_text_1": "Riepilogo",
		"share_map_1": "Mappa",
		"share_save": "Salvataggio eseguito correttamente",
		"share_no_map":"Immagine della mappa non generata",
		"share_update_text": "Modifica il testo della trascrizione",
		"share_update_text2": "Modifica il testo riassuntivo",
		"showLoading": "caricamento...",
		"handwriting": "Contenuto scritto a mano",
		"share_1": "Ари адаҟьаҿы анапылаҩыра аҵакы еилкааӡам",
		"share_2": "Анапылаҩыра аидырра аԥсахра",
		"share_3": "Анапылаҩыра аидырра",
		"share_4":"Esportazione del file, non lasciare questa pagina",
		"folder_text":"Cartella",
		"folder_text_update_name":"Rinomina",
		"folder_text_del":"Elimina",
		"folder_text_all":"Tutto",
		"folder_text_type":"Tipo di file",
		"folder_text_audio":"Note audio",
		"folder_text_writing":"Note scritte a mano",
		"folder_text_file_type":"Tipo di file",
		"folder_text_add":"Crea una nuova cartella",
		"folder_text_input_name":"Inserisci un nome",
		"folder_text_cancel":"Annulla",
		"folder_text_summit":"Conferma",
		"folder_text_name_not_null":"Il nome non può essere vuoto",
		"folder_text_add_success":"Creato con successo!",
		"folder_text_del_confirm":"Eliminazione confermata",
		"folder_text_confirm":"Sei sicuro di Vuoi eliminare la cartella selezionata? Le note nella cartella verranno spostate nel cestino dopo l'eliminazione.",
		"folder_text_del_success":"Eliminazione avvenuta con successo!",
		"folder_text_move":"Spostata in",
		"folder_text_move_success":"Spostata con successo!",
		"folder_update_name":"Cartella rinominata",
		"folder_text_update_success":"Modificata con successo!",
		"empty_text":"Nessun dato disponibile.",
		"trans_text_null":"Il testo trascritto non può essere vuoto",
		"summary_text_null":"Il riepilogo non può essere vuoto",
		"please_create_folder":"Crea prima una cartella"
	}
}